import { Post, Get, Put, Delete } from "@/utils";
import { ApiPath, UserRoles } from "@/enums";

export default {
  namespaced: true,
  state: {
    current_organisation: null,
    certificates: [],
  },
  mutations: {
    SET_ORGANISATION(state, payload) {
      state.current_organisation = payload;
    },
    SET_CERTIFICATES(state, certificates) {
      state.certificates = certificates;
    },
  },
  actions: {
    async getExchangeRates({ }, countryCodes) {
      countryCodes = ["USD"];

      const { data: exchangeRate } = await Get(
        `ExchangeRate?countryCodes=${countryCodes}`,
      );
      return exchangeRate;
    },
    async getAllReferencesByReferenceTypeCategory({ commit }, referenceTypeCategory) {
      const { data: references } = await Get(
        `organisation/getallreferencesbyreferencetypecategory?referenceTypeCategory=${referenceTypeCategory}`,
      );
      commit("SET_CERTIFICATES", references);
      return references;
    },

    async get({ commit }, subdomain) {
      const { data: organisationDetails } = await Get(
        `${ApiPath.Organisation}/getorganisationbysubdomain/${subdomain}`
      );
      if (organisationDetails) {
        commit("SET_ORGANISATION", organisationDetails);
        return organisationDetails;
      }
    },

    getZipCodes({ commit }, param) {
      return axios
        .get(
          `${process.env.VUE_APP_API_BASE_URI}organisation/getZipCodes?zipCode=${param.ZipCode}&miles=${param.Miles}`
        )
        .then((res) => {
          return res;
        });
    }
  },
};
